import type {ChallengeResult, ProgressCallback, WorkerMessageData, WorkerResultData} from "../types";
import {config, exportConfig} from "../utils/config";
import {error} from "../utils/log";
import PowWorker from './pow-worker?worker'

function add(a: string, b: number): bigint {
    return (BigInt(a) + BigInt(b))
}

const decodeHex = (str: string) => {
    let result = new Uint8Array(str.length/2)
    for (let i = 0; i < str.length; i += 2){
        result[i/2] = parseInt(str.substring(i, i + 2), 16)
    }
    return result
}

export function doProofOfWork(
    request: ChallengeResult,
    startNonce: string,
    progressCallback: ProgressCallback,
    signal: AbortSignal,
): Promise<WorkerResultData> {
    return new Promise((resolve, reject) => {
        const threads = config.maxThreads
        const cfg = exportConfig().toString()
        const workers: Worker[] = [];
        const terminate = () => workers.forEach((w) => w.terminate());
        const onerror = (event: ErrorEvent) => {
            Promise.resolve().then(terminate);
            if (event instanceof ErrorEvent) {
                error(`Worker error in ${event.filename} ${event.lineno}:${event.colno}`, event.message, event.error);
                reject(event.error);
            } else {
                error(`Worker error caught:`, event);
                reject(event);
            }
        }
        const onmessage = (event: MessageEvent<WorkerResultData|string>) => {
            if (signal.aborted) {
                Promise.resolve().then(terminate);
                reject(signal.reason);
                return;
            }
            if (typeof event.data === "string") {
                progressCallback(event.data);
            } else {
                terminate();
                resolve(event.data);
            }
        }
        for (let i = 0; i < threads; i++) {
            const worker = new PowWorker();
            worker.onerror = onerror
            worker.onmessage = onmessage
            workers.push(worker);
        }
        workers.forEach((worker, i) => worker.postMessage({
            challenge: decodeHex(request.challenge),
            target: decodeHex(request.target),
            nonce: add(startNonce, i),
            thread: i,
            threads,
            config: cfg,
        } satisfies WorkerMessageData));
    });
}
